const closeBtn = document.getElementById('close-notice-bar');
if (closeBtn) {
    closeBtn.addEventListener('click', function() {
        const noticeBar = this.closest('.notice-bar');
        if (noticeBar) {
            noticeBar.style.display = 'none';
        }
        fetch('/dismiss-site-notification');
    });
}
